import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("singapore",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L24 4.5V12.5L0 12.5L0 4.5Z"
                fill="#ED2939" />
            <path
                d="M5.06722 11.443C6.69217 11.443 8.00944 10.1258 8.00944 8.50082C8.00944 6.87587 6.69217 5.55859 5.06722 5.55859C3.44228 5.55859 2.125 6.87587 2.125 8.50082C2.125 10.1258 3.44228 11.443 5.06722 11.443Z"
                fill="white" />
            <path
                d="M6.39925 11.443C8.0242 11.443 9.34148 10.1258 9.34148 8.50082C9.34148 6.87587 8.0242 5.55859 6.39925 5.55859C4.77431 5.55859 3.45703 6.87587 3.45703 8.50082C3.45703 10.1258 4.77431 11.443 6.39925 11.443Z"
                fill="#ED2939" />
            <path
                d="M6.68592 6.04297L6.23703 7.42964L7.41481 6.57186H5.95703L7.13481 7.42964L6.68592 6.04297Z"
                fill="white" />
            <path
                d="M9.01637 7.7408H7.55859L8.73637 8.59858L8.28748 7.21191L7.83859 8.59858L9.01637 7.7408Z"
                fill="white" />
            <path
                d="M5.24094 10.4873L6.41872 9.62947H4.96094L6.13872 10.4873L5.68983 9.10059L5.24094 10.4873Z"
                fill="white" />
            <path
                d="M8.127 10.4873L7.67811 9.10059L7.22922 10.4873L8.407 9.62947H6.94922L8.127 10.4873Z"
                fill="white" />
            <path
                d="M4.35156 7.7408L5.52934 8.59858L5.08045 7.21191L4.63156 8.59858L5.80934 7.7408H4.35156Z"
                fill="white" />
        </svg>
    `),w=t("singapore_rounded",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135991)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L36 0.5L36 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 0.5L36 0.5V12.5L0 12.5L0 0.5Z"
                    fill="#ED2939" />
                <path
                    d="M8.14771 11.73C10.5851 11.73 12.561 9.75407 12.561 7.31665C12.561 4.87924 10.5851 2.90332 8.14771 2.90332C5.71029 2.90332 3.73437 4.87924 3.73437 7.31665C3.73437 9.75407 5.71029 11.73 8.14771 11.73Z"
                    fill="white" />
                <path
                    d="M10.1477 11.73C12.5851 11.73 14.561 9.75407 14.561 7.31665C14.561 4.87924 12.5851 2.90332 10.1477 2.90332C7.71029 2.90332 5.73438 4.87924 5.73437 7.31665C5.73437 9.75407 7.71029 11.73 10.1477 11.73Z"
                    fill="#ED2939" />
                <path
                    d="M10.5699 3.62988L9.89656 5.70988L11.6632 4.42322H9.47656L11.2432 5.70988L10.5699 3.62988Z"
                    fill="white" />
                <path
                    d="M14.0695 6.17615H11.8828L13.6495 7.46281L12.9761 5.38281L12.3028 7.46281L14.0695 6.17615Z"
                    fill="white" />
                <path
                    d="M8.40438 10.2968L10.171 9.01013H7.98438L9.75104 10.2968L9.07771 8.2168L8.40438 10.2968Z"
                    fill="white" />
                <path
                    d="M12.7354 10.2968L12.0621 8.2168L11.3888 10.2968L13.1554 9.01013H10.9688L12.7354 10.2968Z"
                    fill="white" />
                <path
                    d="M7.07031 6.17615L8.83698 7.46281L8.16365 5.38281L7.49031 7.46281L9.25698 6.17615H7.07031Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135991">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `),d=t("SGD",i`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135991)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L36 0.5L36 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 0.5L36 0.5V12.5L0 12.5L0 0.5Z"
                    fill="#ED2939" />
                <path
                    d="M8.14771 11.73C10.5851 11.73 12.561 9.75407 12.561 7.31665C12.561 4.87924 10.5851 2.90332 8.14771 2.90332C5.71029 2.90332 3.73437 4.87924 3.73437 7.31665C3.73437 9.75407 5.71029 11.73 8.14771 11.73Z"
                    fill="white" />
                <path
                    d="M10.1477 11.73C12.5851 11.73 14.561 9.75407 14.561 7.31665C14.561 4.87924 12.5851 2.90332 10.1477 2.90332C7.71029 2.90332 5.73438 4.87924 5.73437 7.31665C5.73437 9.75407 7.71029 11.73 10.1477 11.73Z"
                    fill="#ED2939" />
                <path
                    d="M10.5699 3.62988L9.89656 5.70988L11.6632 4.42322H9.47656L11.2432 5.70988L10.5699 3.62988Z"
                    fill="white" />
                <path
                    d="M14.0695 6.17615H11.8828L13.6495 7.46281L12.9761 5.38281L12.3028 7.46281L14.0695 6.17615Z"
                    fill="white" />
                <path
                    d="M8.40438 10.2968L10.171 9.01013H7.98438L9.75104 10.2968L9.07771 8.2168L8.40438 10.2968Z"
                    fill="white" />
                <path
                    d="M12.7354 10.2968L12.0621 8.2168L11.3888 10.2968L13.1554 9.01013H10.9688L12.7354 10.2968Z"
                    fill="white" />
                <path
                    d="M7.07031 6.17615L8.83698 7.46281L8.16365 5.38281L7.49031 7.46281L9.25698 6.17615H7.07031Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135991">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as SGD,p as Singapore,w as SingaporeRounded};
